export {default as Body } from './body.component';